
import AttendStampList from './AttendStampList';

export default AttendStampList;
